import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PricingComponent } from '../pricing/pricing.component';
import { SharedModule } from '../shared/shared.module';
import { BestpracticeComponent } from './bestpractice/bestpractice.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { CustomCommonModule } from './common/common.module';
import { DashboardComponent } from './dashboard.component';
import { HomeComponent } from './home/home.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ProfileComponent } from './profile/profile.component';
import { QuestionsComponent } from './questions/questions.component';
import { SettingsComponent } from './settings/settings.component';
import { SubscriptionSuccessComponent } from './subscription-success/subscription-success.component';
import { FixDecimalPipe } from 'src/app/pipes/fix-decimal.pipe';
import { BrandingModule } from './branding/branding.module';
import { RemindersComponent } from './settings/reminders/reminders.component';
import { BillingComponent } from './settings/billing/billing.component';
import { TeamComponent } from './settings/team/team.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'assessments',
        loadChildren: () => import('./assessments/assessments.module').then(m => m.AssessmentsModule)
      },
      {
        path: 'bestpractice',
        component: BestpracticeComponent
      },
      {
        path: 'questions',
        component: QuestionsComponent
      },
      {
        path: 'settings',
        component: SettingsComponent
      },
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'notifications',
        component: NotificationsComponent
      },
      {
        path: 'pricing',
        component: PricingComponent
      },
      {
        path: 'subscription-success',
        component: SubscriptionSuccessComponent
      }
    ]
  }
];

@NgModule({
  declarations: [
    DashboardComponent,
    BestpracticeComponent,
    HomeComponent,
    SettingsComponent,
    BreadcrumbsComponent,
    QuestionsComponent,
    ProfileComponent,
    NotificationsComponent,
    SubscriptionSuccessComponent,
    FixDecimalPipe,
    RemindersComponent,
    BillingComponent,
    TeamComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CustomCommonModule,
    BrandingModule,
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})

export class DashboardModule { }
